import { render, staticRenderFns } from "./FundraisingGoalRewardCard.vue?vue&type=template&id=40a62aec&scoped=true&"
import script from "./FundraisingGoalRewardCard.vue?vue&type=script&lang=ts&"
export * from "./FundraisingGoalRewardCard.vue?vue&type=script&lang=ts&"
import style0 from "./FundraisingGoalRewardCard.vue?vue&type=style&index=0&id=40a62aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a62aec",
  null
  
)

export default component.exports